"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import styles from "./ProductSizeAndFitAccordion.module.scss";
import { Attribute } from "../../../../types/prodcatBaseTypes";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
import { useState } from "react";
type Props = {
  attributes: Attribute[];
  productType: string;
  open?: boolean;
};

export const PRODUCT_SIZE_AND_FIT_ACCORDION_INSTANCE_NAME = "size-and-fit";

export function ProductSizeAndFitAccordionUI({
  attributes,
  productType,
  open,
}: Props) {
  const [isOpen, setIsOpen] = useState(open);
  if (productType === "RetiredStaticBundle") return null;
  if (attributes.length == 0) return null;

  return (
    <ProductAccordionWithMonetateEvents name="Size & Fit" open={isOpen}>
      <Accordion
        id="accordion-size-and-fit"
        className={styles["product-accordion__item"]}
        data-testid="accordion:size-and-fit"
        label="Size and fit"
        animated={true}
        instanceName={PRODUCT_SIZE_AND_FIT_ACCORDION_INSTANCE_NAME}
        responsive
        open={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <dl
          data-testid="product:size-and-fit:list"
          className={styles.productSizeAndFitList}
        >
          {attributes.map((attr) => {
            return (
              <div key={attr.key} className={styles.listItem}>
                <dt
                  data-testid="product:size-and-fit:list:label"
                  className={styles.listTitle}
                >
                  {attr.displayName || attr.key} -{" "}
                </dt>
                <dd
                  data-testid="product:size-and-fit:list:value"
                  className={styles.listDesc}
                >
                  {attr.values}
                </dd>
              </div>
            );
          })}
        </dl>
      </Accordion>
    </ProductAccordionWithMonetateEvents>
  );
}
